import { atom } from 'recoil';

const getSearchParam = (paramName) => {
  // Assuming window.location.search is your query string, e.g. "?param1=value1&param2=value2"
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName); // returns the first value associated with the given search param
};

export const versionAtomDefault = 'Ego4D v2';
export const versionAtom = atom({
  key: 'v',
  default: getSearchParam('v') ? JSON.parse(getSearchParam('v')) : versionAtomDefault,
})

export const siteModeAtom = atom({
  key: 'mode',
  default: 'view' // view | edit
})